import React, {useContext, useMemo} from 'react'
import PriceComponent from './Price'
import {AppContext} from '../../contexts/AppContext'
import {PackageSelectorContext} from '../../contexts/PackageSelectorContext'
import {SpendingContext} from '../../contexts/SpendingContext'
import useSpendingCalc from '../../hooks/useSpendingCalc'

export default function Price(props) {
  const [appState] = useContext(AppContext)
  const [psState] = useContext(PackageSelectorContext)
  const [spendingState] = useContext(SpendingContext)
  const {
    departureServices,
    departureService,
    structures,
    structure,
    programTypologies,
    programTypology,
  } = psState
  const {
    step2InpsServiceId,
    inpsServices,
    step2BonusId,
    step2bonuses,
    step2Coupon,
    step4ExtraServices,
    extraServices,
    applicationType,
    bundles,
    step4Bundles,
  } = appState
  const {
    isLoadingPrice,
    priceToPay,
    totalPrice,
    visualTotalPrice,
    basicCoreCluster,
  } = spendingState
  const {
    getBasicPackagePrice,
    getDepartureServicePrice,
    getProgramTypologyPrice,
    getStructurePrice,
  } = useSpendingCalc()

  const basicCorePrice = getBasicPackagePrice() / 100

  const departureServicePrice = getDepartureServicePrice() / 100

  const structurePrice = getStructurePrice() / 100

  const programTypologyPrice =
    typeof getProgramTypologyPrice === 'function'
      ? getProgramTypologyPrice() / 100
      : 0

  const {
    departureCityLabel,
    structureLabel,
    programTypologyLabel,
    contributoInpsLabel,
    bonusLabel,
    bonusValueLabel
  } = useMemo(() => {
    let departureCityLabel = ''
    let structureLabel = ''
    let programTypologyLabel = ''
    let contributoInpsLabel = ''
    let bonusLabel = ''
    let bonusValueLabel = ''

    if (departureService) {
      const city =
        departureServices.find(item => item.value === departureService) || {}
      departureCityLabel = city.label || ''
    }

    if (structure) {
      const structureT = structures.find(s => s.value === structure) || {}
      structureLabel = structureT.label || ''
    }
    
    if (programTypology) {
      const programTypologyFounded =
        programTypologies.find(pt => pt.value === programTypology) || {}
      programTypologyLabel = programTypologyFounded.label || ''
    }

    // let contributoValue = 0
    if (step2InpsServiceId) {
      const contributoInps = inpsServices.find(
        is => `${is.value}` === step2InpsServiceId
      )
      if (contributoInps) {
        if (contributoInps.isVisualPrice) {
          contributoInpsLabel = `€${contributoInps.visualPriceAmount / 100}`
        } else {
          contributoInpsLabel = contributoInps.ispercentage
          ? `${contributoInps.realvalue / 100}%`
          : `€${contributoInps.realvalue / 100}`
          // contributoValue = contributoInps.ispercentage
          //   ? -((contributoInps.realvalue / 10000) * basicCorePrice)
          //   : contributoInps.realvalue / 100
        }
      }
    }

    // let bonusValue = 0
    if (step2BonusId) {
      const selectedBonus = step2bonuses.find(b => b.value === step2BonusId)
      if (selectedBonus) {
        bonusLabel = selectedBonus.label
        bonusValueLabel = selectedBonus.ispercentage
          ? `${selectedBonus.realvalue / 100}%`
          : `€${selectedBonus.realvalue / 100}`
        //calc bonus value
        // bonusValue = selectedBonus.ispercentage
        //   ? -((selectedBonus.realvalue / 10000) * basicCorePrice)
        //   : selectedBonus.realvalue / 100
      }
    }

    return {
      departureCityLabel,
      structureLabel,
      programTypologyLabel,
      contributoInpsLabel,
      bonusLabel,
      bonusValueLabel
    }
  },[
    departureService,
    departureServices,
    structure,
    structures,
    programTypology,
    programTypologies,
    step2InpsServiceId,
    inpsServices,
    step2BonusId,
    step2bonuses
  ])

  const selectedBundles = useMemo(() => {
    if(step4Bundles.length === 0) {
      return []
    }

    const allBundles = bundles.map(el => {
      const bundle = el.bundles.find(b => step4Bundles.includes(b.id))
      return bundle
    })
    .flat()
    .filter(el => el !== undefined)
    
    return allBundles
  },[bundles, step4Bundles])

  const extraServiceLabels = useMemo(() => {
    return extraServices
    .map(({extraservices, ...bundle}) => ({
      ...bundle,
      es: extraservices.find(es => step4ExtraServices.includes(es.value)),
    }))
    .filter(bundle => Boolean(bundle.es))
    .map(bundle => {
      const es = bundle.es
      const price = es.ispercentage
        ? `${es.realvalue / 100}%`
        : `€${es.realvalue / 100}`
      return {
        id: es.value,
        title: bundle.title,
        value: `${es.label} ${price}`,
        label: es.label,
        realvalue: es.realvalue,
        isVisualPrice: es.isVisualPrice,
      }
    })
  },[extraServices, step4ExtraServices])

  const showInpsContribution =
    (applicationType === 'ada') ? false : contributoInpsLabel

  return (
    <PriceComponent
      isLoadingPrice={isLoadingPrice}
      priceToPay={priceToPay}
      totalPrice={totalPrice}
      visualTotalPrice={visualTotalPrice}
      packageId={psState.package}
      basicCorePrice={basicCorePrice}
      departureService={departureService}
      departureCityLabel={departureCityLabel}
      departureServicePrice={departureServicePrice}
      structure={structure}
      structureLabel={structureLabel}
      structurePrice={structurePrice}
      programTypology={programTypology}
      programTypologyLabel={programTypologyLabel}
      programTypologyPrice={programTypologyPrice}
      contributoInpsLabel={showInpsContribution}
      bonusValueLabel={bonusValueLabel}
      step2Coupon={step2Coupon}
      bonusLabel={bonusLabel}
      extraServiceLabels={extraServiceLabels}
      basicCoreCluster={basicCoreCluster}
      selectedBundles={selectedBundles}
      {...props}
    />
  )
}
